import { lazy, Suspense } from 'react'
// oxlint-disable-next-line no-restricted-imports -- This IS the approved wrapper
import type { LottieComponentProps } from 'lottie-react'

// Lazy-load lottie-react to reduce initial bundle size (~70KB gzipped)
// The library is only needed when Lottie animations are displayed
const LottieComponent = lazy(() => import('lottie-react'))

/**
 * Lazy-loaded Lottie animation component.
 * Reduces initial bundle size by deferring lottie-react load until needed.
 */
function Lottie(props: LottieComponentProps) {
  return (
    <Suspense fallback={null}>
      <LottieComponent {...props} />
    </Suspense>
  )
}

export default Lottie
